import { Config } from "../../../personal-studio-components/service/Config.js";
const StudentService = Config.createService("student_service");
async function add_attachment(data) {
  const baseUrl = await StudentService.getURL();
  const url =
    baseUrl +
    "/student/applications/academic/docs/add/" +
    data.access_token +
    "/" +
    data.study_contract_id +
    "/" +
    data.source_filename +
    "";
  const formData = new FormData();
  formData.append("file", data.file);

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    const abortHandler = () => {
      xhr.abort();
      reject(new Error("Загрузка файла была отменена"));
    };

    xhr.open("POST", url, true);
    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable) {
        let percentage = Math.round((e.loaded * 100) / e.total);
        data.progress_fn(percentage);
      }
    };

    xhr.onload = function () {
      if (this.status === 200) {
        try {
          const responseJson = JSON.parse(xhr.responseText);
          resolve(responseJson);
        } catch (err) {
          window.dispatchEvent(
            new ErrorEvent("error", {
              error_type: "json_parse",
              errors: [err],
            })
          );
          reject(err);
        }
      } else if (this.status === 400) {
        let error = JSON.parse(this.responseText);
        window.dispatchEvent(new ErrorEvent("error", { error }));
        reject(new Error(error.errors[0]));
      } else {
        window.dispatchEvent(
          new ErrorEvent("error", {
            error_type: "upload_file",
            errors: ["Ошибка загрузки файла"],
          })
        );
        reject(new Error("Ошибка загрузки файла " + this.status));
      }

      if (data.signal) {
        data.signal.removeEventListener("abort", abortHandler);
      }
    };

    xhr.onerror = function () {
      window.dispatchEvent(
        new ErrorEvent("error", {
          error_type: "upload_file",
          errors: ["Ошибка загрузки файла"],
        })
      );
      reject(new Error("Ошибка загрузки файла"));

      // Убираем обработчик отмены после ошибки
      if (data.signal) {
        data.signal.removeEventListener("abort", abortHandler);
      }
    };

    // Добавляем обработчик отмены
    if (data.signal) {
      data.signal.addEventListener("abort", abortHandler);
    }
    xhr.send(formData);
  });
}
export default add_attachment;
